import { jsx as _jsx } from "react/jsx-runtime";
import Modal from '../Modal/Modal';
import { getLabels } from '../labels';
import InstantInputDialogContents from './InstantInputDialogContents';
const resolveTitle = (mode, labels) => {
    switch (mode) {
        case 'date':
            return labels.datePlaceholder;
        case 'time':
            return labels.timePlaceholder;
        case 'datetime':
            return labels.dateTimePlaceholder;
        default: {
            const exhaustive = mode;
            return exhaustive;
        }
    }
};
export default function InstantInputModal({ testId, mode, open, onOpenChange, value, onChange, min, max, disablePast, minDate, minuteStep, }) {
    const calendarLabels = getLabels().calendar;
    const handleChange = (committed) => {
        onChange(committed);
        onOpenChange(false);
    };
    return (_jsx(Modal, { testId: testId, title: resolveTitle(mode, calendarLabels), open: open, onOpenChange: onOpenChange, flush: true, width: "sm", children: _jsx(InstantInputDialogContents, { testId: testId.append('contents'), mode: mode, open: open, value: value, onChange: handleChange, min: min, max: max, disablePast: disablePast, minDate: minDate, minuteStep: minuteStep }) }));
}
